import React from "react";
import { Card } from "antd";
import { PieChart } from "@mui/x-charts/PieChart";
import { useTranslation } from "react-i18next";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { grey } from "@mui/material/colors";

const LiabilitiesCard = ({ liabilitiesData }) => {
  const total = liabilitiesData.reduce((sum, item) => sum + item.value, 0);
  const { t } = useTranslation();

  const pieChartData = liabilitiesData.map((item, index) => ({
    id: index,
    value: item.value,
    label: item.label,
    color: item.color,
  }));

  return (
    <Card
      className="col-span-12 md:col-span-6"
      title={t("Liabilities")}
      extra={
        <div className="text-right">
          <span className="text-lg font-bold text-gray-900">
            {t("Total")}: EGP{" "}
          </span>
          <span className="text-lg font-bold text-gray-900">
            {total.toLocaleString()}
          </span>
        </div>
      }
      style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.1)", borderRadius: "16px" }}
    >
      <div className="flex flex-col md:flex-row items-center gap-4 h-[280px] md:h-[200px] overflow-hidden">
        {/* Pie Chart */}
        <PieChart
          series={[
            {
              data: pieChartData,
              innerRadius: 40,
              // arcLabel: (d) => `${d.value.toLocaleString()}`,
              arcLabel: (d) => {
                if (total === 0) return "";
                const percentage = ((d.value / total) * 100).toFixed(1);
                return `${percentage}%`;
              },
              // arcLabel: () => '',
              // arcLabel: () => '',
            },
          ]}
          slotProps={{
            legend: { hidden: true },
            pieArcLabel: {
              style: {
                fontSize: window.innerWidth < 768 ? 28 : 12,
                fontWeight: 600,
                fill: "#fff",
              },
            },
          }}
          width={window.innerWidth < 768 ? 350 : 250}
          height={window.innerWidth < 768 ? 360 : 260}
          margin={{ left: window.innerWidth < 768 ? 0 : -20 }}
        />

        {/* Scrollable Custom Legend Section */}
        <div className="overflow-y-auto h-full w-full md:w-[40%] space-y-3 pe-2 scrollbar-none">
          {liabilitiesData.map((item) => {
            const isVendorDues = item.id === "vendor_dues";

            return (
              <div
                key={item.id}
                className={`relative flex items-center justify-between py-3 px-6 w-full rounded-lg ${
                  isVendorDues ? "min-h-[50px]" : ""
                }`}
                style={{ backgroundColor: item.bg_color }}
              >
                {/* Show filter icon in top-right only for vendor_dues */}
                {isVendorDues && (
                  <div className="absolute top-1 right-1">
                    <FilterAltOffIcon
                      fontSize="small"
                      sx={{ color: grey[500] }}
                    />
                  </div>
                )}

                <div className="flex items-center gap-3">
                  <div
                    // className="w-3 h-3 rounded-full flex-shrink-0"
                    className={`w-3 h-3 rounded-full flex-shrink-0 ${
                      isVendorDues ? "mt-2" : ""
                    }`}
                    style={{ backgroundColor: item.color }}
                  />
                  <span
                    // className="text-xs font-semibold text-gray-700"
                    className={`text-xs font-semibold text-gray-700 ${
                      isVendorDues ? "mt-2" : ""
                    }`}
                  >
                    {t(item.label)}
                  </span>
                </div>

                <span
                  className={`text-xs font-semibold text-gray-700 ${
                    isVendorDues ? "mt-2" : ""
                  }`}
                  // className="text-xs font-bold text-gray-900"
                >
                  EGP {item.value.toLocaleString()}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </Card>
  );
};

export default LiabilitiesCard;
